import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { Button, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import DocumentViewerDialog from '../../documents/DocumentViewerDialog';
import type { Holder, RegistryDocument } from '../../data/types';
import { date } from '../../lib/format';
import { statusLabel } from '../../ui/statusTones';
import { useTenantScope } from '../../store/selectors';
import DataTable from '../../ui/DataTable';
import { useToast } from '../../ui/feedback';
import { SectionCard } from '../../ui/primitives';

export default function HolderDocumentsTab({ holder }: { holder: Holder }) {
  const scope = useTenantScope();
  const toast = useToast();
  const documents = scope.documents.filter((doc) => doc.holderId === holder.id);
  const [viewing, setViewing] = useState<RegistryDocument | null>(null);
  return (
    <SectionCard
      title="Document vault"
      subtitle="Statements, notices, certificates and verification records for this holder"
      noPadding
      action={
        <Button
          size="small"
          variant="outlined"
          onClick={() => toast('Upload dialog (drag and drop) would open here', 'info')}
        >
          Upload
        </Button>
      }
    >
      <DataTable
        rows={documents}
        rowKey={(row) => row.id}
        dense
        defaultSort={{ key: 'date', direction: 'desc' }}
        onRowClick={(row) => setViewing(row)}
        columns={[
          {
            key: 'name',
            label: 'Document',
            sortValue: (row) => row.name,
            render: (row) => (
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.75 }}
              >
                {row.name}
                {!row.visibleToInvestor && (
                  <Tooltip title="Internal only — not visible in the investor app">
                    <VisibilityOffOutlinedIcon fontSize="inherit" color="action" />
                  </Tooltip>
                )}
              </Typography>
            ),
          },
          {
            key: 'kind',
            label: 'Type',
            sortValue: (row) => row.kind,
            render: (row) => statusLabel(row.kind),
          },
          {
            key: 'date',
            label: 'Date',
            sortValue: (row) => row.date,
            render: (row) => date(row.date),
          },
          { key: 'size', label: 'Size', align: 'right', render: (row) => `${row.sizeKb} KB` },
        ]}
      />
      <DocumentViewerDialog doc={viewing} onClose={() => setViewing(null)} />
    </SectionCard>
  );
}
